import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getConductoresTransportista`, method: 'GET', body: null, token: token})
}